// @flow
import React, { Component } from 'react'
import type { Image, Crop, ImageConfig } from '../types'
import SingleImageCropper from './SingleImageCropper'

type Props = {|
  image: Image,
  crop: Crop,
  config: ImageConfig,
  height?: number,
  onCrop: Function
|}

export default class ImageCropper extends Component<Props> {
  render() {
    const { image, height, crop, config } = this.props

    return (
      <SingleImageCropper
        minWidth={config.minWidth}
        minHeight={config.minHeight}
        ratio={config.sizesRelation}
        height={height || 70}
        image={image}
        crop={crop}
        onChange={(crop) => this.onCrop(crop)}
      />
    )
  }

  onCrop(data: Crop) {
    const { onCrop } = this.props

    onCrop(data)
  }
}
